import './index.css';

// Define a minimal emergency UI
const renderEmergencyUI = () => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; padding: 20px; max-width: 800px; margin: 0 auto; text-align: center;">
        <h1 style="color: #333; margin-bottom: 16px;">Glowworm AI Safety</h1>
        <div style="margin-bottom: 24px;">
          <a href="/login" style="display: inline-block; padding: 10px 20px; background-color: #5556A6; color: white; text-decoration: none; border-radius: 4px; margin-right: 16px;">Login</a>
          <a href="/signup" style="display: inline-block; padding: 10px 20px; background-color: #59B98A; color: white; text-decoration: none; border-radius: 4px;">Sign Up</a>
        </div>
        <p style="color: #666;">If you continue seeing this page, please contact support.</p>
      </div>
    `;
  }
};

// Delay importing React to ensure CSS is loaded first
setTimeout(() => {
  try {
    // Dynamically import React to avoid potential issues
    const renderApp = async () => {
      try {
        console.log('Loading React...');
        const React = await import('react');
        const ReactDOM = await import('react-dom/client');
        const { default: App } = await import('./App');
        const { AuthProvider } = await import('./contexts/AuthContext');
        
        console.log('Starting application...');
        const root = document.getElementById('root');
        
        if (root) {
          ReactDOM.createRoot(root).render(
            <AuthProvider>
              <App />
            </AuthProvider>
          );
          console.log('Application rendered successfully');
        } else {
          console.error('Root element not found');
          renderEmergencyUI();
        }
      } catch (error) {
        console.error('Error loading app:', error);
        renderEmergencyUI();
      }
    };

    renderApp();
  } catch (error) {
    console.error('Critical error:', error);
    renderEmergencyUI();
  }
}, 100); // Small delay to ensure CSS loads first